import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Tooltip } from 'bootstrap'

import { clearState, getCartSummary } from '../../../../app/pages/checkout/checkoutActions';
import { formatNavbarBadge } from '../../../helpers/navbarBadge';


const HeaderCartMenu = (props) => {

  var navigate = useNavigate();
  const intl = useIntl()

  //inputs from redux
  const {
    cartSummary
  } = props;

  //actions
  const {
    clearState,
    getCartSummary
  } = props;

  const [items, setItems] = useState([])

  useEffect(() => {
    getCartSummary(true);
    return () => {
      clearState()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {

    if (cartSummary && cartSummary.items) {
      setItems(cartSummary.items)
    }
  }, [cartSummary])

  useEffect(() => {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl)
    })
    return function cleanup() {
      tooltipList.forEach(t => t.dispose())
    };
  }, []);

  const cartBadge = formatNavbarBadge(items.length)

  return (
    <button
      type="button"
      className="app-navbar-trigger"
      onClick={() => navigate("/checkout-management/cart")}
      data-bs-toggle="tooltip"
      title={intl.formatMessage({ id: 'HEADER.SHOPPING_CART' })}
      aria-label={intl.formatMessage({ id: 'HEADER.SHOPPING_CART' })}
    >
      <i className="ki-duotone ki-basket fs-1"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span></i>
      {cartBadge && (
        <span className="badge badge-primary app-navbar-badge">{cartBadge}</span>
      )}
    </button>
  )
}


const mapStateToProps = state => {
  return {
    cartSummary: state.Checkout.cartSummary,
    success: state.Checkout.success
  };
};

const mapActionsToProps = {
  clearState, getCartSummary
}

export default connect(mapStateToProps, mapActionsToProps)(HeaderCartMenu)
